module.exports = __webpack_public_path__ + "static/media/space-needle-compressed.0c647fc8.jpg";